import * as React from 'react';

const ReturnBackIcon = (props) => (
	<svg width={11} height={12} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
		<path
			d='M.766 3.117 3.286.532a.826.826 0 0 1 1.189 0 .879.879 0 0 1 0 1.22l-1.082 1.11H6.4c2.316 0 4.2 1.933 4.2 4.308 0 2.376-1.884 4.31-4.2 4.31a.85.85 0 0 1-.84-.863.85.85 0 0 1 .84-.861c1.389 0 2.52-1.161 2.52-2.586 0-1.424-1.131-2.585-2.52-2.585H3.38L4.467 5.7a.879.879 0 0 1 0 1.22.818.818 0 0 1-1.187 0L.767 4.334a.876.876 0 0 1 0-1.217Z'
			fill='#F8F8FB'
		/>
	</svg>
);

export default ReturnBackIcon;
